import { useEffect, useRef, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Request } from '../../../Api/Requests/models'
import { RejectRequestModal } from './RejectRequestModal'
import { approveRequest, attachPayment } from '../../../Api/Requests/Requests'
import toast from 'react-hot-toast'
import { compressImage, openImage } from '../../../../../Utils/images'

interface OpenRequestModalProps {
    show: boolean
    onHide: () => void
    request: Request
}

export const OpenPaymentRequest = ({ show, onHide, request }: OpenRequestModalProps) => {


    const fileInputRef = useRef<HTMLInputElement>(null)
    const [selectedFile, setSelectedFile] = useState<string>('')
    const [selectedFileBase64, setSelectedFileBase64] = useState<string>('')
    const [showReject, setShowReject] = useState(false)
    const [updatedRequest, setUpdatedRequest] = useState(request)
    const closeBothModals = () => {
        setShowReject(false)
        onHide()
    }

    const handleFileButtonClick = () => {
        fileInputRef.current?.click()
    }

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0]
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const image = e.target?.result as string;
                if (!image.startsWith('data:image/')) {
                    toast.error('El archivo seleccionado no es una imagen')
                    return
                }
                setSelectedFile(file ? file.name : '')

                compressImage(image, (compressedImage) => {
                    setSelectedFileBase64(compressedImage)
                });

            }
            reader.readAsDataURL(file)
        }


    }


    const handleSuccess = async () => {
        try {
            await attachPayment({ id: request.id, base64invoice: selectedFileBase64 })
            onHide()
        } catch (error) {
            toast.error('Ha ocurrido un error al aprobar la petición. Reinicia la página y vuelve a intentarlo.')
            console.log(error)
        }
    }

    useEffect(() => {
        if (request) {
            setUpdatedRequest(request)
        }
    }, [request])


    return (
        <>
            <RejectRequestModal show={showReject} onHide={() => setShowReject(false)} closeBothModals={closeBothModals} request={request} />

            <Modal show={show} onHide={onHide} size='lg' backdrop="static" keyboard={false} centered>
                <div className="border border-secondary rounded-3 px-4">
                    <Modal.Header closeButton>
                        <Modal.Title>Solicitud de Pago<br /> <span className='text-primary'>{request.Player?.platformUser}</span></Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                        <div className='d-flex justify-content-between gap-2 align-items-center'>
                            <div className='text-center w-100 text-primary'>
                                <div>
                                    Se le han bajado {request.amount} fichas al usuario {request.Player?.platformUser}.
                                </div>
                                <div className='text-warning'>Verifica la información, haz el pago, y adjunte el comprobante.</div>
                            </div>
                        </div>
                        <hr />

                        <div>
                            <div className="mt-2">
                                Solicitud de <span className="text-primaryy">Pago</span>
                            </div>
                            <div className="mt-2">
                                Bajadas: <span className="text-primaryy">{request.amount}</span>
                            </div>
                            <div className="mt-2">
                                Titular cuenta destinatario: <span className="text-primaryy">{request.recipient ?? '-'}</span>
                            </div>
                            <div className="mt-2">
                                CBU del destinatario: <span className="text-primaryy">{request.recipientBankAccount}</span>
                            </div>

                            <div className='mt-4'>Comentarios:
                                <textarea className="text-primaryy form-control"
                                    value={updatedRequest.reason ?? ''}
                                    onChange={(e) => setUpdatedRequest({ ...updatedRequest, reason: e.target.value })}
                                />
                            </div>
                            <div className='text-secondary text-xs text-end'>* Los comentarios serán visibles para el cliente.</div>
                            <hr />

                            <div className='d-flex justify-content-around align-items-center gap-2'>
                                <div className='mt-3'>
                                    <div>
                                        <label className="text-xs mb-2">Adjunta una imagen del comprobante de pago</label>
                                        <input
                                            type="file"
                                            className='form-control custom-file-input'
                                            id='file'
                                            accept='image/*'
                                            ref={fileInputRef}
                                            onChange={handleFileChange}
                                            style={{ display: 'none' }}
                                        />
                                        <div className="d-flex flex-column gap-2">
                                            <Button
                                                variant='outline-primary'
                                                className='w-100'
                                                onClick={handleFileButtonClick}
                                            >
                                                Seleccionar archivo
                                            </Button>
                                            {selectedFile && (
                                                <div className="text-secondary small">
                                                    Archivo seleccionado: {selectedFile}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {selectedFileBase64 && <div className='d-flex flex-column gap-2'>
                                    <div role='button'>
                                        <img src={selectedFileBase64} alt="Comprobante" width={100} onClick={() => openImage(selectedFileBase64)} />
                                        <div className='text-secondary text-center w-100 text-xxs'>Comprobante</div>
                                    </div>
                                </div>}
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <div className='d-flex justify-content-between w-100'>
                            <div className='d-flex align-items-center gap-2'>
                                {request?.status === 'pendingpayment' && <Button variant="danger" onClick={() => setShowReject(true)}> Rechazar </Button>}
                            </div>
                            <div className='d-flex align-items-center gap-2'>
                                <Button variant="primary" onClick={handleSuccess} disabled={!selectedFileBase64}>Guardar</Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </div >
            </Modal >
        </>
    )
}
